import '../../assets/components/ProductCardSolo/productcardsolo.css';const o = "_anchor_1u3v5_1", t = "_productcardsolo_1u3v5_19", c = "_body_1u3v5_29", e = "_content_1u3v5_38", _ = "_imageWrapper_1u3v5_49", r = "_placeholder_1u3v5_55", a = "_image_1u3v5_49", n = "_productname_1u3v5_67", d = "_withCert_1u3v5_73", p = {
  anchor: o,
  productcardsolo: t,
  body: c,
  content: e,
  imageWrapper: _,
  placeholder: r,
  image: a,
  productname: n,
  withCert: d
};
export {
  o as anchor,
  c as body,
  e as content,
  p as default,
  a as image,
  _ as imageWrapper,
  r as placeholder,
  t as productcardsolo,
  n as productname,
  d as withCert
};
